import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getCustomProfitByDays,
  getDataByDays,
  setDataByDays,
  setTotalProfit,
  setCustomProfitByDays,
  getTotalPlan,
  getTopManagementReportsFilters,
  getProfitPlansWidgetData,
  setTopManagementReportsFilters,
  getProfitPlanOffers,
  getExecPlan,
  getMarginPlan,
  getCustomFilters,
  getMarginFilter,
  getAggregatedManagersProfit,
  getAggregatedOfferProfit,
  setProfitPlansWidgetData,
  getHRDetailedOffers,
  setHRDetailedOffers
} from "../../../store/plans/actions";
import {
  getAggregatedStaffData,
  setAggregatedStaffData
} from "../../../store/invoices/actions";
import ModifiedMetaTags from "../../../components/ModifiedMetaTags/index";
import DefaultOverview from "./pages/DefaultOverview";
import HROverview from "./pages/HROverview";

const indexPage = props => {
  const getOverviewPage = () => {
    const { permissions } = props;

    if (permissions['is_hr'] && !permissions['is_admin']) {
      return <HROverview
        history={props.history}
        topReportsFilters={props.topReportsFilters}
        topReportsWidgets={props.topReportsWidgets}
        profitByDays={props.profitByDays}
        filter_data={props.filter_data}
        getTopManagementReportsFilters={props.getTopManagementReportsFilters}
        getProfitPlansWidgetData={props.getProfitPlansWidgetData}
        topReportsLoading={props.topReportsLoading}
        topReportsFiltersLoading={props.topReportsFiltersLoading}
        setTopManagementReportsFilters={props.setTopManagementReportsFilters}
        profitPlanOffers={props.profitPlanOffers}
        getProfitPlanOffers={props.getProfitPlanOffers}
        customFilters={props.customFilters}
        customLoader={props.customLoader}
        getCustomFilters={props.getCustomFilters}
        aggregatedOfferData={props.aggregatedOfferData}
        loaderAggregatedOffer={props.loaderAggregatedOffer}
        getAggregatedOfferProfit={props.getAggregatedOfferProfit}
        user={props.user}
        permissions={props.permissions}
        setProfitPlansWidgetData={props.setProfitPlansWidgetData}
        staffData={props.staffData}
        staffLoaderData={props.staffLoaderData}
        getAggregatedStaffData={props.getAggregatedStaffData}
        setAggregatedStaffData={props.setAggregatedStaffData}
        getHRDetailedOffers={props.getHRDetailedOffers}
        hrOffersData={props.hrOffersData}
        hrOffersDataLoader={props.hrOffersDataLoader}
      />
    } else {
      return <DefaultOverview
        history={props.history}
        topReportsFilters={props.topReportsFilters}
        topReportsWidgets={props.topReportsWidgets}
        totalProfit={props.totalProfit}
        profitByDays={props.profitByDays}
        customProfitByDayData={props.customProfitByDayData}
        getCustomProfitByDays={props.getCustomProfitByDays}
        getDataByDays={props.getDataByDays}
        setDataByDays={props.setDataByDays}
        setTotalProfit={props.setTotalProfit}
        setCustomProfitByDays={props.setCustomProfitByDays}
        getTotalPlan={props.getTotalPlan}
        totalPlan={props.totalPlan}
        filter_data={props.filter_data}
        getTopManagementReportsFilters={props.getTopManagementReportsFilters}
        getProfitPlansWidgetData={props.getProfitPlansWidgetData}
        topReportsLoading={props.topReportsLoading}
        topReportsFiltersLoading={props.topReportsFiltersLoading}
        setTopManagementReportsFilters={props.setTopManagementReportsFilters}
        profitPlanOffers={props.profitPlanOffers}
        getProfitPlanOffers={props.getProfitPlanOffers}
        profitPlanMargin={props.profitPlanMargin}
        profitPlanExecution={props.profitPlanExecution}
        getExecPlan={props.getExecPlan}
        getMarginPlan={props.getMarginPlan}
        customFilters={props.customFilters}
        customLoader={props.customLoader}
        getCustomFilters={props.getCustomFilters}
        marginFilters={props.marginFilters}
        marginLoader={props.marginLoader}
        getMarginFilter={props.getMarginFilter}
        aggregatedManagersData={props.aggregatedManagersData}
        loaderAggregatedManagers={props.loaderAggregatedManagers}
        aggregatedOfferData={props.aggregatedOfferData}
        loaderAggregatedOffer={props.loaderAggregatedOffer}
        loaderDataByDays={props.loaderDataByDays}
        dataByDays={props.dataByDays}
        getAggregatedManagersProfit={props.getAggregatedManagersProfit}
        getAggregatedOfferProfit={props.getAggregatedOfferProfit}
        user={props.user}
        permissions={props.permissions}
        setProfitPlansWidgetData={props.setProfitPlansWidgetData}
      />
    }
  }

  const renderOverviewName = () => {
    const { permissions } = props;
    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"] ||
      permissions['is_finance'] ||
      permissions['is_hr']
    ) {
      return "Top Management";
    }

    if (permissions["is_accountmanager"] || permissions["is_mediabuyer"]) {
      return "Individual Report";
    }

    return "Top Management";
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title={`${renderOverviewName()} | Mobihunter`} />
          {getOverviewPage()}
        </div>
      </React.Fragment>
    </>
  );
};

indexPage.propTypes = {
  history: PropTypes.any,
  topReportsFilters: PropTypes.object,
  topReportsWidgets: PropTypes.array,
  totalProfit: PropTypes.array,
  profitByDays: PropTypes.array,
  customProfitByDayData: PropTypes.array,
  // getTotalProfit: PropTypes.func,
  getCustomProfitByDays: PropTypes.func,
  getDataByDays: PropTypes.func,
  setDataByDays: PropTypes.func,
  setTotalProfit: PropTypes.func,
  setCustomProfitByDays: PropTypes.func,
  getTotalPlan: PropTypes.func,
  totalPlan: PropTypes.array,
  filter_data: PropTypes.object,
  getTopManagementReportsFilters: PropTypes.func,
  getProfitPlansWidgetData: PropTypes.func,
  topReportsLoading: PropTypes.bool,
  topReportsFiltersLoading: PropTypes.bool,
  setTopManagementReportsFilters: PropTypes.func,
  profitPlanOffers: PropTypes.object,
  getProfitPlanOffers: PropTypes.func,
  profitPlanMargin: PropTypes.any,
  profitPlanExecution: PropTypes.any,
  getExecPlan: PropTypes.func,
  getMarginPlan: PropTypes.func,
  customFilters: PropTypes.object,
  customLoader: PropTypes.bool,
  getCustomFilters: PropTypes.func,
  marginFilters: PropTypes.array,
  marginLoader: PropTypes.bool,
  getMarginFilter: PropTypes.func,
  aggregatedManagersData: PropTypes.object,
  loaderAggregatedManagers: PropTypes.bool,
  aggregatedOfferData: PropTypes.object,
  loaderAggregatedOffer: PropTypes.bool,
  loaderDataByDays: PropTypes.bool,
  dataByDays: PropTypes.any,
  getAggregatedManagersProfit: PropTypes.func,
  getAggregatedOfferProfit: PropTypes.func,
  user: PropTypes.object,
  permissions: PropTypes.any,
  setProfitPlansWidgetData: PropTypes.func,
  staffData: PropTypes.any,
  staffLoaderData: PropTypes.bool,
  getAggregatedStaffData: PropTypes.func,
  setAggregatedStaffData: PropTypes.func,
  getHRDetailedOffers: PropTypes.func,
  setHRDetailedOffers: PropTypes.func,
  hrOffersData: PropTypes.any,
  hrOffersDataLoader: PropTypes.bool,
};

const mapStateToProps = state => ({
  filter_data: state.PlanList.filter_data,
  totalProfit: state.PlanList.totalProfit,
  customProfitByDayData: state.PlanList.customProfitByDays,
  dataByDays: state.PlanList.dataByDays,
  loaderDataByDays: state.PlanList.loaderDataByDays,
  totalPlan: state.PlanList.totalPlan,
  topReportsFilters: state.PlanList.topReportsFilters,
  topReportsFiltersLoading: state.PlanList.topReportsLoader,
  topReportsWidgets: state.PlanList.topReportsWidgets,
  topReportsLoading: state.PlanList.topReportsLoading,
  profitPlanOffers: state.PlanList.profitPlanOffers,
  profitPlanExecution: state.PlanList.profitPlanExecution,
  profitPlanMargin: state.PlanList.profitPlanMargin,
  customFilters: state.PlanList.customFilters,
  customLoader: state.PlanList.customLoader,
  marginFilters: state.PlanList.marginFilters,
  marginLoader: state.PlanList.marginLoader,
  aggregatedManagersData: state.PlanList.aggregatedManagersData,
  loaderAggregatedManagers: state.PlanList.loaderAggregatedManagers,
  aggregatedOfferData: state.PlanList.aggregatedOfferData,
  loaderAggregatedOffer: state.PlanList.loaderAggregatedOffer,
  user: state.User.user_settings,
  permissions: state.User.permissions,
  staffData: state.InvoiceList.staffData,
  staffLoaderData: state.InvoiceList.staffLoaderData,
  hrOffersData: state.PlanList.hrOffersData,
  hrOffersDataLoader: state.PlanList.hrOffersDataLoader,
});

export default connect(mapStateToProps, {
  getCustomProfitByDays,
  getDataByDays,
  setDataByDays,
  setTotalProfit,
  setCustomProfitByDays,
  getTotalPlan,
  getTopManagementReportsFilters,
  getProfitPlansWidgetData,
  setTopManagementReportsFilters,
  getProfitPlanOffers,
  getExecPlan,
  getMarginPlan,
  getCustomFilters,
  getMarginFilter,
  getAggregatedManagersProfit,
  getAggregatedOfferProfit,
  setProfitPlansWidgetData,
  getAggregatedStaffData,
  setAggregatedStaffData,
  getHRDetailedOffers,
  setHRDetailedOffers
})(indexPage);
